import React, {
  useState,
  useEffect,
  useContext,
  useLayoutEffect,
  useMemo,
} from "react";
import { AuthContext } from "../../contexts/AuthContext";
import axios from "axios";
import Header from "../../layout/Header/Header";

import { Row, Input, Col } from "reactstrap";
import moment from "moment";
import Swal from "sweetalert2";
import {
  DashPage,
  FilterBar,
  Filtro,
  FiltroSeparador,
  BotonActualizar,
  KpiRow,
  DashCard,
  ChartBox,
  BarRow,
  EmptyState,
  montarGraficas,
  graficaDona,
  fmtMoneda,
  fmtNumero,
  pctDe,
} from "./dashboardUI";

function DashboardCobranza() {
  const { user } = useContext(AuthContext);
  const URL_DASHBOARDS = process.env.REACT_APP_URL_DASHBOARDS;
  const AREAS_CEDIS = process.env.REACT_APP_AREAS_CEDIS;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 90);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [graficasArea, setGraficasArea] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [vendedores, setVendedores] = useState([]);
  const [selectedVendedor, setSelectedVendedor] = useState("");

  const [graficasCEDIS, setGraficasCEDIS] = useState([]);

  const [info, setInfo] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [totalTotal, setTotalTotal] = useState(0);
  const [totalAbonos, setTotalAbonos] = useState(0);
  const [totalBonificaciones, setTotalBonificaciones] = useState(0);
  const [totalDevoluciones, setTotalDevoluciones] = useState(0);
  const [totalAnticipos, setTotalAnticipos] = useState(0);

  const Toast = Swal.mixin({
    toast: true,
    position: "center",
    showConfirmButton: false,
    // timer: 5000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  if (cargando) {
    Toast.fire({
      html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`, // Ícono de carga animado
      title: "Danos unos segundos....",
      customClass: {
        icon: 'animated-icon'
      }
    });
  }

  useEffect(() => {
    axios
      .get(
        `${URL_DASHBOARDS}Cobranza/${selectedFechaInicio}/${selectedFechaFin}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then((response) => {
        let totalTotal = 0;

        let allGraficas = response.data;
        let arrayTabla = allGraficas
          .map((a) => {
            totalTotal = totalTotal + parseFloat(a.Abonos);
            if (a.Concepto == "Abono") {
              return {
                Concepto: "Abono",
                idCliente: a.idCliente,
                Cliente: a.Cliente,
                idVendedor: a.idVendedor,
                Vendedor: a.Vendedor,
                Area: a.Area,
                idArea: a.idArea,
                Importe: parseFloat(a.Abonos),
                Abonos: parseFloat(a.Abonos),
                Bonificaciones: 0,
                Devoluciones: 0,
                Anticipos: 0,
              };
            } else if (a.Concepto == "Bonificacion") {
              return {
                Concepto: "Bonificacion",
                idCliente: a.idCliente,
                Cliente: a.Cliente,
                idVendedor: a.idVendedor,
                Vendedor: a.Vendedor,
                Area: a.Area,
                idArea: a.idArea,
                Importe: parseFloat(a.Abonos),
                Abonos: 0,
                Bonificaciones: parseFloat(a.Abonos),
                Devoluciones: 0,
                Anticipos: 0,
              };
            } else if (a.Concepto == "Devolucion") {
              return {
                Concepto: "Devolucion",
                idCliente: a.idCliente,
                Cliente: a.Cliente,
                idVendedor: a.idVendedor,
                Vendedor: a.Vendedor,
                Area: a.Area,
                idArea: a.idArea,
                Importe: parseFloat(a.Abonos),
                Abonos: 0,
                Bonificaciones: 0,
                Devoluciones: parseFloat(a.Abonos),
                Anticipos: 0,
              };
            } else if (a.Concepto.includes("Anticipo")) {
              return {
                Concepto: "Anticipo",
                idCliente: a.idCliente,
                Cliente: a.Cliente,
                idVendedor: a.idVendedor,
                Vendedor: a.Vendedor,
                Area: a.Area,
                idArea: a.idArea,
                Importe: parseFloat(a.Abonos),
                Abonos: 0,
                Bonificaciones: 0,
                Devoluciones: 0,
                Anticipos: parseFloat(a.Abonos),
              };
            }
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setInfo(dataFinal);
        setTotalTotal(totalTotal);

        let unicosCli = dataFinal.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idCliente === value.idCliente)
        );
        setClientes(unicosCli);

        let unicosVend = dataFinal.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idVendedor === value.idVendedor)
        );
        setVendedores(unicosVend);

        setCargando(false);
        Toast.close();
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function BuscaInfo() {
    setInfo([]);
    setSelectedCliente("");
    setSelectedVendedor("");
    setCargando(true);
    axios
      .get(
        `${URL_DASHBOARDS}Cobranza/${selectedFechaInicio}/${selectedFechaFin}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then((response) => {
        let totalTotal = 0;

        let allGraficas = response.data;
        let arrayTabla = allGraficas
          .map((a) => {
            totalTotal = totalTotal + parseFloat(a.Abonos);
            if (a.Concepto == "Abono") {
              return {
                Concepto: "Abono",
                idCliente: a.idCliente,
                Cliente: a.Cliente,
                idVendedor: a.idVendedor,
                Vendedor: a.Vendedor,
                Area: a.Area,
                idArea: a.idArea,
                Importe: parseFloat(a.Abonos),
                Abonos: parseFloat(a.Abonos),
                Bonificaciones: 0,
                Devoluciones: 0,
                Anticipos: 0,
              };
            } else if (a.Concepto == "Bonificacion") {
              return {
                Concepto: "Bonificacion",
                idCliente: a.idCliente,
                Cliente: a.Cliente,
                idVendedor: a.idVendedor,
                Vendedor: a.Vendedor,
                Area: a.Area,
                idArea: a.idArea,
                Importe: parseFloat(a.Abonos),
                Abonos: 0,
                Bonificaciones: parseFloat(a.Abonos),
                Devoluciones: 0,
                Anticipos: 0,
              };
            } else if (a.Concepto == "Devolucion") {
              return {
                Concepto: "Devolucion",
                idCliente: a.idCliente,
                Cliente: a.Cliente,
                idVendedor: a.idVendedor,
                Vendedor: a.Vendedor,
                Area: a.Area,
                idArea: a.idArea,
                Importe: parseFloat(a.Abonos),
                Abonos: 0,
                Bonificaciones: 0,
                Devoluciones: parseFloat(a.Abonos),
                Anticipos: 0,
              };
            } else if (a.Concepto.includes("Anticipo")) {
              return {
                Concepto: "Anticipo",
                idCliente: a.idCliente,
                Cliente: a.Cliente,
                idVendedor: a.idVendedor,
                Vendedor: a.Vendedor,
                Area: a.Area,
                idArea: a.idArea,
                Importe: parseFloat(a.Abonos),
                Abonos: 0,
                Bonificaciones: 0,
                Devoluciones: 0,
                Anticipos: parseFloat(a.Abonos),
              };
            }
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setInfo(dataFinal);
        setTotalTotal(totalTotal);

        let unicosCli = dataFinal.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idCliente === value.idCliente)
        );
        setClientes(unicosCli);

        let unicosVend = dataFinal.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idVendedor === value.idVendedor)
        );
        setVendedores(unicosVend);

        setCargando(false);
        Toast.close();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useMemo(() => {
    let temp = info;
    if (selectedCliente) {
      temp = temp.filter((e) => e.idCliente.includes(selectedCliente));
    }

    if (selectedVendedor) {
      temp = temp.filter((e) => e.idVendedor.includes(selectedVendedor));
    }

    let agrupadoArea = temp.reduce(function (groups, item) {
      const val = item["idArea"] + item["Concepto"];
      groups[val] = groups[val] || {
        idArea: item.idArea,
        Importe: 0,
        Abonos: 0,
        Bonificaciones: 0,
        Devoluciones: 0,
        Anticipos: 0,
      };
      groups[val].Importe += item.Importe;
      groups[val].Abonos += item.Abonos;
      groups[val].Bonificaciones += item.Bonificaciones;
      groups[val].Devoluciones += item.Devoluciones;
      groups[val].Anticipos += item.Anticipos;
      groups[val].Concepto = item.Concepto;
      groups[val].Area = item.Area;
      groups[val].idArea = item.idArea;
      return groups;
    }, []);

    let otraArea = Object.values(agrupadoArea);

    setGraficasArea(otraArea);

    let temp2 = otraArea
      .filter((e) => e.idArea.includes(AREAS_CEDIS))
      .sort((a, b) => (a.Importe < b.Importe ? 1 : -1));

    setGraficasCEDIS(temp2);

    let TTot = temp.map((c) => parseFloat(c.Importe));
    let TT = TTot.reduce((t, total, index) => t + total, 0);
    setTotalTotal(TT);

    let TAbo = temp.map((c) => parseFloat(c.Abonos));
    let TA = TAbo.reduce((t, total, index) => t + total, 0);
    setTotalAbonos(TA);

    let Tbon = temp.map((c) => parseFloat(c.Bonificaciones));
    let TB = Tbon.reduce((t, total, index) => t + total, 0);
    setTotalBonificaciones(TB);

    let Tdev = temp.map((c) => parseFloat(c.Devoluciones));
    let TD = Tdev.reduce((t, total, index) => t + total, 0);
    setTotalDevoluciones(TD);

    let TAnt = temp.map((c) => parseFloat(c.Anticipos));
    let TAn = TAnt.reduce((t, total, index) => t + total, 0);
    setTotalAnticipos(TAn);
  }, [info, selectedCliente, selectedVendedor]);

  useLayoutEffect(
    () =>
      montarGraficas([
        ["chartdivCEDIS", (root) => graficaDona(root, { data: graficasCEDIS, valor: "Importe", categoria: "Concepto", moneda: true })],
      ]),
    [graficasCEDIS]
  );

  const pctTxt = (v) => `${fmtNumero(pctDe(v, totalTotal), 1)}% del total`;

  const kpis = [
    { label: "Total general", value: totalTotal, formato: "moneda", icon: "fas fa-dollar-sign", color: "#22c55e" },
    { label: "Abonos", value: totalAbonos, formato: "moneda", icon: "fas fa-hand-holding-usd", color: "#3b82f6", pct: pctDe(totalAbonos, totalTotal), sub: pctTxt(totalAbonos) },
    { label: "Bonificaciones", value: totalBonificaciones, formato: "moneda", icon: "fas fa-gift", color: "#f59e0b", pct: pctDe(totalBonificaciones, totalTotal), sub: pctTxt(totalBonificaciones) },
    { label: "Devoluciones", value: totalDevoluciones, formato: "moneda", icon: "fas fa-undo-alt", color: "#ef4444", pct: pctDe(totalDevoluciones, totalTotal), sub: pctTxt(totalDevoluciones) },
    { label: "Anticipos", value: totalAnticipos, formato: "moneda", icon: "fas fa-piggy-bank", color: "#8b5cf6", pct: pctDe(totalAnticipos, totalTotal), sub: pctTxt(totalAnticipos) },
  ];

  return (
    <>
      <Header />
      {/* {user.menu_reportes ? ( */}
      <DashPage
        icon="fas fa-dollar-sign"
        color="#22c55e"
        bg="#f0fdf4"
        title="Dashboard Cobranza"
        subtitle="Abonos, bonificaciones, devoluciones y anticipos del período"
        cargando={cargando}
      >
        <FilterBar>
          <Filtro label="Fecha inicio" chico>
            <Input
              bsSize="sm"
              type="date"
              value={selectedFechaInicio}
              onChange={(e) => {
                setSelectedFechaInicio(e.target.value);
              }}
            />
          </Filtro>
          <Filtro label="Fecha fin" chico>
            <Input
              bsSize="sm"
              type="date"
              value={selectedFechaFin}
              onChange={(e) => {
                setSelectedFechaFin(e.target.value);
              }}
            />
          </Filtro>
          <BotonActualizar onClick={BuscaInfo} cargando={cargando} />

          <FiltroSeparador />

          <Filtro label="Cliente">
            <Input
              bsSize="sm"
              type="select"
              value={selectedCliente}
              onChange={(e) => {
                setSelectedCliente(e.target.value);
              }}
            >
              <option value="">Todos</option>
              {clientes
                .sort((a, b) => (a.Cliente > b.Cliente ? 1 : -1))
                .map((a) => {
                  return <option key={a.idCliente} value={a.idCliente}>{a.Cliente}</option>;
                })}
            </Input>
          </Filtro>

          <Filtro label="Vendedor">
            <Input
              bsSize="sm"
              type="select"
              value={selectedVendedor}
              onChange={(e) => {
                setSelectedVendedor(e.target.value);
              }}
            >
              <option value="">Todos</option>
              {vendedores
                .sort((a, b) => (a.Vendedor > b.Vendedor ? 1 : -1))
                .map((a) => {
                  return <option key={a.idVendedor} value={a.idVendedor}>{a.Vendedor}</option>;
                })}
            </Input>
          </Filtro>
        </FilterBar>

        <KpiRow items={kpis} />

        <Row className="dash-row">
          <Col lg={6}>
            <DashCard icon="fas fa-warehouse" color="#22c55e" title="Cobranza CEDIS" subtitle="Importe por concepto">
              <ChartBox id="chartdivCEDIS" height={320} cargando={cargando} vacio={graficasCEDIS.length === 0} />
            </DashCard>
          </Col>
          <Col lg={6}>
            <DashCard icon="fas fa-layer-group" color="#3b82f6" title="Composición de la cobranza" subtitle="Cada concepto contra el total general">
              {!cargando && totalTotal === 0 ? (
                <EmptyState />
              ) : (
                <div style={{ paddingTop: 6 }}>
                  {[
                    { label: "Abonos", valor: totalAbonos, color: "#3b82f6" },
                    { label: "Bonificaciones", valor: totalBonificaciones, color: "#f59e0b" },
                    { label: "Devoluciones", valor: totalDevoluciones, color: "#ef4444" },
                    { label: "Anticipos", valor: totalAnticipos, color: "#8b5cf6" },
                  ].map((c) => (
                    <BarRow
                      key={c.label}
                      label={c.label}
                      value={fmtMoneda(c.valor)}
                      pct={pctDe(c.valor, totalTotal)}
                      color={c.color}
                      sub={pctTxt(c.valor)}
                    />
                  ))}
                  <div style={{ display: "flex", justifyContent: "space-between", borderTop: "1px solid var(--border)", paddingTop: 10, marginTop: 4, fontSize: "0.8rem", fontWeight: 700 }}>
                    <span>Total general</span>
                    <span style={{ color: "#22c55e" }}>{fmtMoneda(totalTotal)}</span>
                  </div>
                </div>
              )}
            </DashCard>
          </Col>
        </Row>
      </DashPage>
      {/*  ) : undefined} */}
    </>
  );
}
export default DashboardCobranza;
